import { INotification, NotificationType } from 'src/api/getNotifications/getNotifications';

/**
 * The review is raised on one channel's event. Its parent is the root publish, which the status page
 * needs to show every plan under it, and which accepts or rejects them together.
 */
export const getPublishRootEventId = ({ parent_event_id, event_id }: INotification): string =>
  parent_event_id ?? event_id;

export const isPublishReviewFor =
  (rootEventId: string) =>
  (notification: INotification): boolean =>
    notification.type === NotificationType.PUBLISH_REVIEW && getPublishRootEventId(notification) === rootEventId;
